import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import serviceImg from '../assets/Services1.webp'; // replace with your image
import { FaTools, FaUsersCog, FaWarehouse } from "react-icons/fa";
const Service = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="hero-fullwidth h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">

        <h1 className="text-white text-4xl md:text-5xl font-bold">Service</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Service
        </div>
      </div>

      {/* Animated Section */}
      <div className="max-w-7xl mx-auto py-20 px-6">
        <div className="flex flex-col md:flex-row items-center gap-10">
          
          {/* Left Text Content */}
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2 space-y-6"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">Exceptional Service & Support</h2>
            <p className="text-gray-700 text-lg">
              At WVT Lifts, we have over 150+ employees, 3 branches, and 5 service centers in North India, with the installed base of over 750+ elevators and 10+ escalators.
            </p>

            <h3 className="text-xl font-semibold text-gray-800">24/7 Emergency Response</h3>
            <p className="text-gray-700">
              Commitment to quick and reliable emergency repair services, especially crucial for businesses relying on elevators.
            </p>

            <h3 className="text-xl font-semibold text-gray-800">Proactive Maintenance</h3>
            <p className="text-gray-700">
              Preventative maintenance programs to minimize downtime and extend the lifespan of elevators.
            </p>

            <h3 className="text-xl font-semibold text-gray-800">Customized Solutions</h3>
            <p className="text-gray-700">
              Ability to tailor elevator installations and services to meet specific client needs and building requirements.
            </p>

            <h3 className="text-xl font-semibold text-gray-800">Warranty and Service Packages</h3>
            <p className="text-gray-700">
              Competitive warranties and comprehensive service packages that include regular maintenance and upgrades.
            </p>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <img
              src={serviceImg}
              alt="Service"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </motion.div>

        </div>
        


{/* Why Choose Us Section */}
<div className="w-full bg-gray-50 py-20 px-6">
  {/* Headings */}
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
    className="text-center mb-16"
  >
    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
      WHY CHOOSE US
    </h2>
    <p className="text-xl md:text-2xl font-semibold text-gray-800 mt-4">
      HIGH QUALITY CUSTOMER SERVICE
    </p>
  </motion.div>

  {/* Columns */}
  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
    
    {/* Feature 1 */}
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.1 }}
      viewport={{ once: true }}
      className="flex flex-col items-center text-center space-y-4"
    >
      <FaTools className="text-blue-600 text-5xl" />
      <h3 className="text-2xl font-bold text-gray-900">
        100% Hassle Free Service Plan
      </h3>
      <p className="text-gray-700 text-lg">
        Multiple and varied options for annual maintenance and service.
      </p>
    </motion.div>

    {/* Feature 2 */}
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      viewport={{ once: true }}
      className="flex flex-col items-center text-center space-y-4"
    >
      <FaUsersCog className="text-green-600 text-5xl" />
      <h3 className="text-2xl font-bold text-gray-900">
        Dedicated Smart Service Setup
      </h3>
      <p className="text-gray-700 text-lg">
        Periodical preventive maintenance by highly trained field technicians and quicker customer response.
      </p>
    </motion.div>

    {/* Feature 3 */}
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.3 }}
      viewport={{ once: true }}
      className="flex flex-col items-center text-center space-y-4"
    >
      <FaWarehouse className="text-orange-600 text-5xl" />
      <h3 className="text-2xl font-bold text-gray-900">
        Varied Service Centers
      </h3>
      <p className="text-gray-700 text-lg">
        Genuine parts from our 5 service centers and stores for our AMC customers.
      </p>
    </motion.div>

  </div>
</div>
      </div>
    </div>
  );
};

export default Service;
